import React from "react"
import Link from "../AntiLink"
import "./style.css"
import "./style-rtl.css"
import { Icon } from "react-icons-kit"
import { BsTwitterX } from "react-icons/bs"
import { facebook } from "react-icons-kit/fa/facebook"
import { instagram } from "react-icons-kit/fa/instagram"
import { whatsapp } from "react-icons-kit/fa/whatsapp"
import { language } from "react-icons-kit/fa/language"
import { useScroll } from "../../hooks/useScroll"
import logo from "../../images/logo.png"
import navigations from "../../../content/data/navigations.yml"
import { Box } from "theme-ui"

const styles = {
  boxShadow: "0 0 3px 1px #2125296b",
  padding: "12px 7px",
}
const Header = ({ lang }) => {
  const { scrollY } = useScroll()

  const isArabic = lang === "ar"
  const urlPrefix = isArabic ? "/ar" : ""
  const SwitchLanguageLink = isArabic ? "/" : "/ar/"
  const SwitchLanguageHint = isArabic ? "English" : "عربي"
  const defaultStyle = {
    display: ["none", null, null, "block"],
  }
  return (
    <>
      <Box
        as="header"
        sx={scrollY !== 0 ? { ...styles, ...defaultStyle } : defaultStyle}
      >
        <div className="header d-flex align-items-center justify-content-between container-wrap pb-0">
          <div className="logo">
            <Link to={isArabic ? "/ar/" : "/"}>
              <img className="header-logo" src={logo} alt="" />
            </Link>
          </div>
          <div>
            <div className="nav-list">
              {navigations.map(item => (
                <Link to={urlPrefix + item.uri} className="btn text-light">
                  {item.titleobj[lang]}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <div className="d-flex">
              <a
                className="b-socials"
                href="https://www.facebook.com/benchmarkae/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon icon={facebook} className="fa fa-facebook fa-fw" />
              </a>
              <a
                className="b-socials"
                href="https://twitter.com/Benchmarkae"
                target="_blank"
                rel="noopener noreferrer"
              >
                <BsTwitterX />
              </a>
              <a
                className="b-socials"
                href="https://www.instagram.com/bmdsae/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon icon={instagram} className="fa fa-instagram fa-fw" />
              </a>
              <a
                className="b-socials"
                href="https://wa.me/971554111919"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon icon={whatsapp} className="fa fa-instagram fa-fw" />
              </a>
              <Link to={SwitchLanguageLink} className="b-socials pointer">
                <Icon
                  icon={language}
                  className="fa fa-language fa-fw"
                  title={SwitchLanguageHint}
                />
              </Link>
            </div>
          </div>
        </div>
      </Box>
    </>
  )
}

export default Header
